
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    btyUrl: {
      type: String,
      required: true,
    },
  },
  render() {
    return (
      <div class="app-nav container">
        <div class="app-nav__nav">
          <img
            class="app-nav__brand"
            src={require("./logo.png")}
            alt="B SPORTS"
          />
          <a class="cursor-default">体育竞技</a>
          <a class="cursor-default">真人视讯</a>
          <a class="cursor-default">电子捕鱼</a>
          <a class="cursor-default">棋牌游戏</a>
          <a class="cursor-default">电子竞技</a>
          <a class="cursor-default">
            优惠活动<span class="app-nav__hot">热</span>
          </a>
        </div>
        <a
          class="btn btn-primary"
          href={`${this.btyUrl}/login/register`}
          target="_blank"
        >
          立即注册
        </a>
      </div>
    );
  },
});
